import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";
import colors from "constants/palette";
// import { BellOutlined, ArrowLeftOutlined } from "@ant-design/icons";

export default function Header({ color, textColor, value, text, link }) {
  if (link && link.startsWith("https")) {
    return (
      <ExternalContainerLink
        href={link}
        target="_blank"
        referrerPolicy="no-referrer"
        color={color}
        textcolor={textColor}
      >
        <p>{text}</p>
        <span>{value}</span>
      </ExternalContainerLink>
    );
  }
  return (
    <ContainerLink to={link ? link : "#"} color={color} textcolor={textColor}>
      <p>{text}</p>
      <span>{value}</span>
    </ContainerLink>
  );
}
const baseStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  padding: 0 24px;
  margin: 8px 0;

  min-width: 200px;
  width: 29%;
  height: 96px;
  background-color: ${({ color }) => (color ? color : "#f2da24")};

  box-shadow: 0px 0px 10px 1px
    ${({ color }) => (color ? color + "30" : "#f2da2430")};

  border-radius: 9px;
  color: ${({ textcolor }) => (textcolor ? textcolor : colors.white)};
  &:hover,
  &:active,
  &:focus {
    color: ${({ textcolor }) => (textcolor ? textcolor : colors.white)};
  }
  & span {
    font-weight: bold;
    font-size: 20px;
    text-align: end;
  }
  & p {
    margin: 0;
    font-size: 15px;
    text-align: start;
  }

  @media (max-width: 480px) {
    flex-direction: row;
    height: auto;
    padding: 16px 12px;
    align-items: center;
  }
`;
const ContainerLink = styled(NavLink)`
  ${baseStyles}
`;
const ExternalContainerLink = styled.a`
  ${baseStyles}
`;
